import refreshCsrfToken from './refresh-csrf-token.js';

export function normalize(value) {
    return (value ?? '').toString().trim().toLowerCase();
}

export function isHtmlInputElement(value) {
    return typeof HTMLInputElement !== 'undefined' && value instanceof HTMLInputElement;
}

export function parseDatasetClassnames(el) {
    if (!el?.dataset?.classnames) return [];
    return el.dataset.classnames
        .toString()
        .split(/\s+/)
        .map((c) => c.trim())
        .filter(Boolean);
}

/**
 * Get a CSRF token for custom JavaScript requests.
 *
 * This intentionally fetches lazily instead of on page load. Sprig/Craft forms
 * should keep the CSRF tokens they rendered with; custom fetch requests should
 * ask for a token at the moment they need one.
 *
 * @param {boolean} forceRefresh
 * @returns {Promise<{name: string, value: string}|null>}
 */
export async function getCsrfToken(forceRefresh = false) {
    return refreshCsrfToken.getTokenAsync(forceRefresh);
}
